import { Skeleton } from 'antd';

export function SidebarSkeleton() {
    return (
        <div className="w-64 h-screen bg-background shadow-md p-4 flex flex-col space-y-4">
            {/* Logo Placeholder */}
            <Skeleton.Input active size="default" className="w-32 mb-6" />

            {/* Menu item placeholders */}
            {[...Array(6)].map((_, idx) => (
                <Skeleton.Button
                    key={idx}
                    active
                    size="default"
                    shape="round"
                    className="w-full h-10"
                />
            ))}

            {/* Optional: smaller skeleton for footer or extra items */}
            <div className="mt-auto">
                <Skeleton.Input active size="small" className="w-20" />
            </div>
        </div>
    );
}
